// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1tQvQ","calendarButtons":"ClockData_calendarButtons__1kgrW"};